import { Metrics } from 'reporting-ui-components/monitoring/Metrics';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { INLINE_MULTI_ACCOUNT_LABEL_RENDERED } from '../../constants/trackingMetrics';
import { StandardInlineLabel } from './labelComponents/StandardInlineLabel';
import { getMultiAccountPortalIds, isMultiAccountReport } from 'reporting-data/tsTypes/reportTypes';
import { useEffect, useMemo } from 'react';
// @ts-expect-error Untyped import
import { Label } from './Label';
import { useMultiAccountOptions } from 'reporting-snowflake/relational/hooks/useMultiAccountOptions';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const condition = ({
  report
}) => {
  return report && isMultiAccountReport(report);
};
export const render = Label(({
  report
}) => {
  const {
    accountsData
  } = useMultiAccountOptions({
    selectedAccountIds: []
  });
  const tooltipContent = useMemo(() => {
    if (!(accountsData !== null && accountsData !== void 0 && accountsData.accounts)) {
      return undefined;
    }
    const multiAccountPortalIds = report ? getMultiAccountPortalIds(report) : [];
    const header = I18n.text(multiAccountPortalIds.length === 1 ? 'settingLabels.multiAccount.tooltip.accountHeader' : 'settingLabels.multiAccount.tooltip.accountsHeader');
    const accountNames = multiAccountPortalIds.map(portalId => {
      const accountName = accountsData.accounts[String(portalId)];
      return accountName || I18n.text('settingLabels.multiAccount.tooltip.disconnectedAccount', {
        portalId
      });
    });
    const conjunction = I18n.text('settingLabels.multiAccount.tooltip.conjunction');
    let tooltipText;
    if (accountNames.length === 1) {
      tooltipText = accountNames[0];
    } else if (accountNames.length === 2) {
      tooltipText = `${accountNames[0]} ${conjunction} ${accountNames[1]}`;
    } else {
      tooltipText = `${accountNames.slice(0, -1).join(', ')}, ${conjunction} ${accountNames[accountNames.length - 1]}`;
    }
    return {
      header,
      tooltipText
    };
  }, [accountsData, report]);
  useEffect(() => {
    Metrics.counter(INLINE_MULTI_ACCOUNT_LABEL_RENDERED).increment();
  }, []);
  return /*#__PURE__*/_jsx(StandardInlineLabel, {
    tooltipProps: tooltipContent ? {
      headingText: tooltipContent.header,
      title: tooltipContent.tooltipText
    } : {},
    inlineLabelBadgeText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingLabels.multiAccount.inlineLabel"
    }),
    dataTestId: "inline-multi-account-label"
  });
});